export const _SEARCH = {
    SEARCH_LISTINGS_REQUEST: 'SEARCH_LISTINGS_REQUEST',
    SEARCH_LISTINGS_SUCCESS: 'SEARCH_LISTINGS_SUCCESS',
    SEARCH_LISTINGS_FAILURE: 'SEARCH_LISTINGS_FAILURE'
}